export const list = {
  title: {
    name: '任务标题',
    key: 'title',
    width: 500,
    check: true
  },
  task_sn: {
    name: '任务编号',
    key: 'task_sn',
    width: 190
  },
  type: {
    name: '优先级',
    key: 'type',
    width: 120
  },
  endtime: {
    name: '截止日期',
    key: 'endtime',
    width: 120
  },
  principal_name: {
    name: '执行人',
    key: 'principal_name',
    wdith: 70
  },
  complete_time: {
    name: '完成时间',
    key: 'complete_time',
    width: 120
  },
  status: {
    name: '状态',
    key: 'status',
    width: 120
  },
  project_title: {
    name: '所属项目',
    key: 'project_title',
    wdith: 180,
    check: true
  }
};
